export const customToolbar = (
  <span className="ql-formats">
    <select className="ql-size">
      <option value="small" />
      <option value="normal" />
      <option value="large" />
      <option value="huge" />
    </select>
    <button className="ql-bold" />
    <button className="ql-italic" />
    <button className="ql-underline" />
    <button className="ql-strike" />
    <button className="ql-clean" />
    <button className="ql-list" value="ordered" />
    <button className="ql-list" value="bullet" />
    <select className="ql-color" />
    <select className="ql-background" />
    <button className="ql-link" />
  </span>
);
